import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import {
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
} from '../../shared/constants'

const getHomePageData = ({ countryId, clientId }) => {
  const query = `query ($countryId: ID!, $clientId: ID, $statuses: [CampaignStatusEnum!]) {
    country (id: $countryId) {
      countryDefaultSettings {
        enabledChannelBroadAreas,
        enabledChannelPreciseLocations,
        enabledChannelLetterbox,
        enabledChannelEddm,
        enabledChannelAdm,
        baPerLocation
      }
      code
    }
    campaignsBuilderData(input: { clientId: $clientId, statuses: $statuses }){
      totalCount
      nodes {
        campaignId
        startDate
        internalStatus
        campaignName
        createdAt
        paymentStatus
        lastActiveStep
        type
        subtype
        reviewMeetingDate
        workflowId
      }
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, {
    countryId,
    clientId,
    statuses: [STATUS_CAMPAIGN_ENUM_DRAFT, STATUS_CAMPAIGN_ENUM_ACTIVE],
  })
}

const getSubmittedCampaigns = ({ clientId }) => {
  const query = `query ($clientId: ID, $statuses: [CampaignStatusEnum!]) {
    campaignsBuilderData(input: { clientId: $clientId, statuses: $statuses }){
      totalCount
      nodes {
        campaignId
        internalStatus
        reviewMeetingDate
        workflowId
      }
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, {
    clientId,
    statuses: [
      STATUS_CAMPAIGN_ENUM_DRAFT,
      STATUS_CAMPAIGN_ENUM_ACTIVE,
      STATUS_CAMPAIGN_ENUM_COMPLETED,
      STATUS_CAMPAIGN_ENUM_ARCHIVE,
    ],
  })
}

export { getHomePageData, getSubmittedCampaigns }
